import React, { useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import { useAPI } from '../../api';

import TenantsListContainer from './TenantsListContainer';
import TenantCreateNewContainer from './TenantCreateNewContainer';
import TenantContainer from './TenantContainer';
import { TenantInfo } from 'types';
import { useOrgContext } from 'components/OrgContextProvider';

const TenantsContainer = () => {
	const api = useAPI();
	const ctx = useOrgContext();

	const [tenants, setTenants] = useState<TenantInfo[]>([]);

	// // https://stackoverflow.com/a/46240804
	// const [, updateState] = React.useState();
	// const forceUpdate = React.useCallback(() => updateState({}), []);

	const loadTenants = () => {
		ctx?.reload?.();

		api.get<TenantInfo[]>('/api/tenants')
		.then(json => setTenants(json));
	};

	useEffect(() => {
		loadTenants();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Routes>
			<Route path="/" element={<TenantsListContainer tenants={tenants} onChanged={loadTenants} />} />
			<Route path="/new" element={<TenantCreateNewContainer onChanged={loadTenants} />} />
			<Route path="/:tenantID/*" element={<TenantContainer />} />
		</Routes>
	);
};

export default TenantsContainer;
